'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSbAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29.0002 2.52724e-05H1.00019V20H29.0002V2.52724e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29.0002 -0.0035553H1.00019V19.9964H29.0002V-0.0035553Z",
          fill: "#1DBE4F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.00019 -0.0035553H29.0002L1.00019 19.9964V-0.0035553Z",
          fill: "#0660D4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.0002 -0.0035553L1.00019 19.9964H29.0002V-0.0035553Z",
          fill: "#2C7442"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.207 -0.00390625L0.982208 17.3196L1.00019 19.9964L1.82932 20.0006L29 2.65625L29.0002 -0.0035553L28.207 -0.00390625Z",
          fill: "#FFD646"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.99999 3.82978L3.02035 4.34481L3.20745 3.25396L2.4149 2.48142L3.51017 2.32226L3.99999 1.32978L4.48982 2.32226L5.58509 2.48142L4.79254 3.25396L4.97964 4.34481L3.99999 3.82978ZM10.6667 3.82978L9.68702 4.34481L9.87411 3.25396L9.08157 2.48142L10.1768 2.32226L10.6667 1.32978L11.1565 2.32226L12.2518 2.48142L11.4592 3.25396L11.6463 4.34481L10.6667 3.82978ZM10.6667 7.82978L9.68702 8.34481L9.87411 7.25396L9.08157 6.48142L10.1768 6.32226L10.6667 5.32978L11.1565 6.32226L12.2518 6.48142L11.4592 7.25396L11.6463 8.34481L10.6667 7.82978ZM3.99999 7.82978L3.02035 8.34481L3.20745 7.25396L2.4149 6.48142L3.51017 6.32226L3.99999 5.32978L4.48982 6.32226L5.58509 6.48142L4.79254 7.25396L4.97964 8.34481L3.99999 7.82978ZM7.33333 5.82978L6.35369 6.34481L6.54078 5.25396L5.74823 4.48142L6.84351 4.32226L7.33333 3.32978L7.82315 4.32226L8.91842 4.48142L8.12587 5.25396L8.31297 6.34481L7.33333 5.82978Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagSbAsset = forwardRef(FlagSbAsset);

export { VpFlagSbAsset as default };
